import * as React from "react";
const Workshop = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={32}
    height={32}
    x={0}
    y={0}
    viewBox="0 0 64 64"
    style={{
      enableBackground: "new 0 0 512 512",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <g>
      <circle
        cx={47.788}
        cy={14.808}
        r={4.407}
        fill={props.fill}
        opacity={1}
        data-original="#000000"
      />
      <path
        d="M53.179 20.66H40.206a3.17 3.17 0 0 0-2.174.863l-2.765 2.63c-.398.368-.99.397-1.417.077l-2.035-1.58a1.493 1.493 0 1 0-1.809 2.376l3.378 2.523a2.5 2.5 0 0 0 2.698.194l3.774-1.892c.27-.135.584-.127.862-.03.72.253.71.93.71 1.547v18.693c0 1.206.868 2.307 2.068 2.425a2.304 2.304 0 0 0 2.531-2.288v-9.625c0-.592.486-1.077 1.087-1.077.602 0 1.087.485 1.087 1.077v9.488c0 1.206.868 2.307 2.068 2.425a2.304 2.304 0 0 0 2.531-2.288V26.821a1.083 1.083 0 0 1 2.164 0v4.609c0 .747.611 1.349 1.358 1.349.748 0 1.359-.602 1.359-1.35v-6.267a4.502 4.502 0 0 0-4.502-4.503z"
        fill={props.fill}
        opacity={1}
        data-original="#000000"
      />
      <path
        d="M11.091 26.218h17.36a3.426 3.426 0 0 1 2.454-5.822c.757 0 1.504.252 2.096.718l.766.601V11.178a.973.973 0 0 0-.97-.97H11.091a.973.973 0 0 0-.97.97v14.07c0 .533.436.97.97.97zm4.91-11.906h11.886c.534 0 .97.437.97.97 0 .534-.436.97-.97.97H16.001a.973.973 0 0 1-.97-.97c0-.533.436-.97.97-.97zm0 3.736h11.886c.534 0 .97.436.97.97 0 .543-.436.97-.97.97H16.001a.967.967 0 0 1-.97-.97c0-.534.436-.97.97-.97z"
        fill={props.fill}
        opacity={1}
        data-original="#000000"
      />
      <circle
        cx={14.263}
        cy={39.574}
        r={4.743}
        fill={props.fill}
        opacity={1}
        data-original="#000000"
      />
      <path
        d="M17.37 45.288h-6.214a4.837 4.837 0 0 0-4.837 4.836v3.668h15.888v-3.668a4.837 4.837 0 0 0-4.836-4.836z"
        fill={props.fill}
        opacity={1}
        data-original="#000000"
      />
      <circle
        cx={31.122}
        cy={39.574}
        r={4.743}
        fill={props.fill}
        opacity={1}
        data-original="#000000"
      />
      <path
        d="M34.23 45.288h-6.216a4.837 4.837 0 0 0-4.836 4.836v3.668h15.888v-3.668a4.837 4.837 0 0 0-4.836-4.836z"
        fill={props.fill}
        opacity={1}
        data-original="#000000"
      />
    </g>
  </svg>
);
export default Workshop;
